import * as React from 'react';
import Dropzone, { FileWithPreview } from 'react-dropzone';
import { Glyphicon } from 'react-bootstrap';
import * as sa from 'superagent';
import EditorProps from '../../components/editorinterface';
import { File } from '../../store/types';
import { ColumnsCount } from './types';
import Tiles from './Tiles';
import Gallery from './Gallery';
import './index.css';
import * as NProgress from 'nprogress';
import 'nprogress/nprogress.css';

interface Props extends EditorProps {
  apiUrl: string,
  isNewRow: boolean;
  b_o: string;
  token: string;
};

interface State {
    photoIndex: number;
    galleryIsOpen: boolean;
    showModal: boolean;
    nCols: ColumnsCount;
}

class FileEditor extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
        photoIndex: 0,
        galleryIsOpen: false,
        showModal: false,
        nCols: getColsCount(window.innerWidth)
    };

    this.onDrop = this.onDrop.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.openGallery = this.openGallery.bind(this);
    this.closeGallery = this.closeGallery.bind(this);
    this.onMovePrevRequest = this.onMovePrevRequest.bind(this);
    this.onMoveNextRequest = this.onMoveNextRequest.bind(this);
    this.updateCols = this.updateCols.bind(this);
  }

  componentDidMount() {
      window.addEventListener("resize", this.updateCols);
  }

  render() {
	var buttonText = this.props.field.buttonText ? this.props.field.buttonText : "Drop files here";
    const { photoIndex, galleryIsOpen, nCols } = this.state;
    const files = this.props.value || [];
    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          className="btn btn-default btn-block"
        >
          <Glyphicon glyph="send" style={{ marginRight: '10px' }} />
			  {buttonText}
        </Dropzone>
        <Tiles
          files={files}
          deleteFile={this.deleteFile}
          downloadFile={this.downloadFile}
          openGallery={this.openGallery}
          nCols={nCols}
        />
        { (files.length > 0)
          ? (
            <Gallery
              images={getImages(files)}
              previews={getPreviewImages(files)}
              imageTitle={(files[photoIndex] !== undefined) ? files[photoIndex].name : ''}
              photoIndex={photoIndex}
              isOpen={galleryIsOpen}
              closeGallery={this.closeGallery}
              onMovePrevRequest={this.onMovePrevRequest}
              onMoveNextRequest={this.onMoveNextRequest}
              deleteFile={this.deleteFile}
              downloadFile={this.downloadFile}
              nCols={nCols}
            />
          )
          : null
        }

      </div>
    );

  }


  private deleteFile(index: number): void {
    const files = this.props.value.concat([]);
    files.splice(index, 1);
    this.props.onChange(this.props.field.id, files);
    if(!this.state.galleryIsOpen) {
      return;
    }
    if(files.length===0) {
      this.closeGallery();
      return;
    }
    if(index===files.length) {
      this.onMovePrevRequest();
    }
  }

  private downloadFile(index: number): void {
    const file = this.props.value[index] as File;
    window.open(file.url);
  }

  private openGallery(photoIndex: number): void {
    this.setState({ photoIndex, galleryIsOpen: true });
  }

  private closeGallery() {
    this.setState({ galleryIsOpen: false });
  }

  private onMovePrevRequest() {
    const photoIndex = this.state.photoIndex;
    const len = this.props.value.length;
    this.setState({ photoIndex: (photoIndex + len - 1) % len });
  }

  private onMoveNextRequest() {
    const photoIndex = this.state.photoIndex;
    const len = this.props.value.length;
    this.setState({ photoIndex: (photoIndex + 1) % len });
  }
  

  private updateCols(): void {
    const nCols = getColsCount(window.innerWidth);
    if (nCols !== this.state.nCols)
      this.setState({nCols});
  }

  private onDrop(acceptedFiles: Array<FileWithPreview>) {
    if(acceptedFiles.length===0) {
      return;
    }
    NProgress.start();
	const props = this.props;
    const req = sa.post(props.apiUrl + '/upload?b_o=' + props.b_o + (props.isNewRow ? '&vt=' : '&t=') + props.token);
    acceptedFiles.forEach(file => {
        req.attach(file.name, file);
    });
    req.then(res => {
      if(res.body.status !== "ok") {
        return;
      }
      props.onChange(props.field.id,res.body.files.concat(props.value || []))
    }).catch(err => {
    }).then(function() {
      NProgress.done();
    });
  }
}


const getImages = (files: Array<File>) : Array<string> => {
  // TODO get images from api
  const images :Array<string> = [];
  files.forEach(file => images.push(file.preview));
  return images;
}

const getPreviewImages = (files: Array<File>): Array<string> => {
  // TODO get previews from api
  const previews :Array<string> = [];
  files.forEach(file => previews.push(file.preview));
  return previews;
}


function getColsCount(currentWindowWidth: number): ColumnsCount {
    // bootstrap Grid's xs, sm, md, lg pixel count
    // https://www.w3schools.com/bootstrap/bootstrap_grid_system.asp
    const pixelThresholds = [768, 992, 1200];
    const maxCols = 3;
    let nCols: ColumnsCount = 1;
    pixelThresholds.forEach((windowWidth) => {
      if (currentWindowWidth >= windowWidth)
        nCols++;
    });
    return (nCols <= maxCols) ? nCols : maxCols;
}

export default FileEditor;



// WEBPACK FOOTER //
// ./src/components/fileeditor/index.tsx